export const ORDERS_PER_CYCLE = 10;
export const APPROVED_ORDER_STATUSES = ["PAID", "SENT", "RECEIVED"];
export const EXTRAPAY_SUCCESS_CODE = 200001;

// Mesmo OTP por e-mail do saque normal (/withdraw/requestotp)
export const EXTRAPAY_WITHDRAW_OTP_LENGTH = 6;
export const EXTRAPAY_WITHDRAW_OTP_TTL_MS = 60 * 60 * 1000;
export const EXTRAPAY_OTP_INVALID_CODE = 500166;

export const EXTRAPAY_PATH = "/dashboard-financeiro/extrapay";
export const EXTRAPAY_KNOW_PATH = "/dashboard-financeiro/extrapay/conheca";
export const EXTRAPAY_WITHDRAW_PATH = "/dashboard-financeiro/extrapay/saque";
export const EXTRAPAY_CYCLE_PATH = "/dashboard-financeiro/extrapay/ciclo";
export const EXTRAPAY_RATE_ANCHOR = "extrapay-rate";

export const extrapayWithdrawDetailsPath = (id) =>
  `/dashboard-financeiro/extrapay/saques/${id}`;

export const extrapayTabPath = (tab) => `${EXTRAPAY_PATH}?tab=${tab}`;
